<!-- 组织架构 -->
<template>
	<div>
		<!-- logo区域 -->
		<logo-head></logo-head>
		<!-- 导航菜单 -->
		<nav-head></nav-head>
		<!-- banner图 -->
		<banner></banner>
		<!-- 主体 -->
		<div class="structure">
			<div class="structureContent">
				<div class="text-center">
					<span class="font-weight-bold" style="font-size: 24px;">行业资讯</span>
				</div>
				<!-- 主体内容 -->
				<div class="mt-4 bg-white contentDetail">
					<div class="detailList">
						<ul>
							<li v-for="(item,index) in newsList" :key="index" @click="goDetail(item)" :title="item.name">
								{{item.name.length > 45 ? item.name.substr(0,45) + '..' : item.name}}
								<span class="rightDate">{{item.createAt}}</span>
							</li>
						</ul>
					</div>
				</div>
				<!-- 分页 -->
				<div class="text-center mt-3">
					<el-pagination background layout="prev, pager, next"
					@current-change="getNews" :current-page="paging.currPage"
					:page-size="paging.everySize" :total="paging.allNum">
					</el-pagination>
				</div>
			</div>
		</div>
		<!-- footer -->
		<Footer :bgColor="'#2c68ff'"></Footer>
	</div>
</template>

<script>
	import logoHead from '../../components/logoHead/logoHead.vue'
	import navHead from '../../components/navHead/navHead.vue'
	import banner from '../../components/banner/banner.vue'
	import Footer from '../../components/footer/footer.vue'
	export default{
		components: {
			logoHead,
			navHead,
			banner,
			Footer
		},
		mounted() {
			this.getNews()
		},
		data() {
			return {
				newsList:[],
				paging: {currPage: 1, everySize:10, allNum: 0},
				//检索条件
				condition: {}
			}
		},
		methods: {
			// 获取新闻列表
			getNews(currentPage){
				let vm = this
				// 区分分页与查询
				if(currentPage){
				   vm.paging.currPage = currentPage;
				} else {
				   vm.paging.currPage = 1;
				} 
				var params = {}
				params.currPage = vm.paging.currPage
				params.everySize = vm.paging.everySize
				vm.axios.get('/api/irpi/industry/information/findAllByPage',{params: params}).then(res => {
					vm.newsList = res.data.data.industryInformations
					vm.paging = res.data.data.pagingBean
				})
			},
			goDetail(item){
				if(item.reprintMark){
					window.open(item.reprintUrl, '_blank');
				}
				let routeData = this.$router.resolve({
					path:'/irpiNewsDetail',
					query:{
						id:item.id,
						mbx:'行业资讯',
						mbxLink:'/news',
						newsType:'information'
					}
				})
				window.open(routeData.href, '_blank');
			}
		},
	}
</script>

<style scoped>
.structure{
	width: 100%;
	min-height:600px;
	overflow: hidden;
	background-color: #F8F8F8;
}
.structure .structureContent{
	width: 1200px;
	min-height:600px;
	margin: 0 auto;
	margin-bottom: 50px;
	padding:20px 60px;
}
.contentDetail{
	min-height: 600px;
}
.contentDetail ul li{
	font-size: 18px;
	color: #666;
	height: 70px;
	border-bottom: 1px solid #eee;
	line-height: 70px;
	position: relative;
}
.contentDetail ul li .rightDate{
	position: absolute;
	right:20px;
}
.contentDetail ul li:hover{
	cursor: pointer;
	color: #409Eff;
}
</style>

